module.exports = __webpack_public_path__ + "static/01_Track-card sort.38fb1740.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/auspost/01_Track-card sort.jpg
// module id = 475
// module chunks = 110568472390859